import { FC } from "react";

import {
  cvFromChatToSubscriptionPocContext,
  CvFromChatToSubscriptionPocContextValue,
} from "./CvFromChatToSubscriptionPocContext";

export const CvFromChatToSubscriptionPocProvider: FC<CvFromChatToSubscriptionPocContextValue> =
  ({ children, ...props }) => (
    <cvFromChatToSubscriptionPocContext.Provider value={props}>
      {children}
    </cvFromChatToSubscriptionPocContext.Provider>
  );
